import { render, staticRenderFns } from "./SensorBox.vue?vue&type=template&id=b4c2cfcc&scoped=true"
import script from "./SensorBox.vue?vue&type=script&lang=js"
export * from "./SensorBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c2cfcc",
  null
  
)

export default component.exports